<template>
  <div class="metals">
    <div class="metals-block metals-block_rate" v-if="silver">
      <img class="image" src="../images/icons/silver.svg">
      <div class="metals-block-textSilver">{{silver}} ₽</div>
    </div>
    <div class="metals-block metals-block_rate" v-if="!silver">
      <div class="metals-block-textSilver fs12">Данные обновляются</div>
    </div>

    <a
      class="metals-support"
      :href="donationUrl"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Поддержать проект через ЮMoney"
      title="Поддержать проект"
      @click="trackDonationClick"
    >
      <img class="metals-support-icon" src="../images/icons/support.svg" alt="">
    </a>

    <div class="metals-block metals-block_rate" v-if="gold">
      <img class="image" src="../images/icons/gold.svg">
      <div class="metals-block-textGold">{{gold}} ₽</div>
    </div>
    <div class="metals-block metals-block_rate" v-if="!gold">
      <div class="metals-block-textGold  fs12">Данные обновляются</div>
    </div>
  </div>
</template>

<script setup>
import {useMetalsStore} from "@/stores/metalsPrice/metalsStore"
import { onMounted, computed, ref } from "vue";
import { trackGoal } from '@/helpers/metrika'

const metalsStore = useMetalsStore();
const metalsData = computed(() => metalsStore.data)
const silver = ref('')
const gold = ref('')
const donationUrl = "https://yoomoney.ru/fundraise/1JAP6JIRQGO.260729"
const trackDonationClick = () => {
  trackGoal('donation_click', { provider: 'yoomoney' })
}
onMounted(async () => {
  await metalsStore.fetchData()
  metalsPrice()
})
const metalsPrice = () => {
  silver.value = metalsData.value?.silver ?? 0
  gold.value = metalsData.value?.gold ?? 0
}
</script>

<style lang="scss" scoped>
.metals {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  width: 90vw;
  &-block {
    display: flex;
    justify-content: flex-start;
    padding: 5px;
    box-shadow: 0px 0px 2px 2px rgba(0, 0, 0, 0.25);
    border-radius: 33px;
    background-color: #ffffff14;
    align-items: center;
    min-height: 40px;
    &_rate {
      flex: 1 1 0;
      min-width: 0;
    }
    &-textSilver {
      margin: 0 auto;
      font-size: 16px;
      color: #fff;
    }
    &-textGold {
      margin: 0 auto;
      font-size: 16px;
      color: #f8e472;
    }
  }
  &-support {
    display: flex;
    align-items: center;
    flex: 0 0 42px;
    justify-content: center;
    width: 42px;
    height: 42px;
    padding: 0;
    border-radius: 50%;
    background-color: #ffffff14;
    box-shadow: 0px 0px 2px 2px rgba(0, 0, 0, 0.25);
    color: #fff;
    text-decoration: none;
    transition: transform 0.16s ease, background-color 0.16s ease, color 0.16s ease;
  }
  &-support:hover {
    background-color: rgba(255, 255, 255, 0.1);
  }
  &-support:active {
    transform: scale(0.93);
    background-color: rgba(255, 255, 255, 0.14);
  }
  &-support:active .metals-support-icon {
    filter: brightness(0) saturate(100%) invert(92%) sepia(42%) saturate(673%) hue-rotate(352deg) brightness(101%) contrast(94%);
  }
  &-support:focus-visible {
    outline: 2px solid #f8e472;
    outline-offset: 3px;
  }
  &-support-icon {
    width: 28px;
    height: 28px;
  }
}
.image {
  height: 30px;
  width: 30px;
  margin-left: 10px;
}
.fs12 {
  font-size: 12px !important;
}
</style>
